const fields = ["Tak", "Nie"];

export default fields;
